// extracted by mini-css-extract-plugin
module.exports = {"text":"ErrorNotice_text__sBCoZ"};